"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _BrixelIcon = _interopRequireDefault(require("./BrixelIcon"));
var _translation = _interopRequireDefault(require("../Translation/translation"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelTooltip = props => {
  const {
    children,
    className = '',
    classNameIconWrap = '',
    defaultShowTooltip = false,
    descClass = '',
    description = '',
    hideIcon = false,
    icon = '',
    iconColor = '',
    label = '',
    lang = 'en',
    theme = 'dark',
    width = '360'
  } = props;
  const [showTooltip, setShowTooltip] = (0, _react.useState)(defaultShowTooltip);
  const [tooltipPos, setTooltipPos] = (0, _react.useState)('center');
  const [tooltipWidth, setTtipWidth] = (0, _react.useState)(width);
  const [animClass, setAnimClass] = (0, _react.useState)('');
  const refDesc = (0, _react.useRef)(null);
  const bounding = (0, _get.default)(refDesc, 'current', null) ? refDesc.current.getBoundingClientRect() : null;
  (0, _react.useEffect)(() => {
    if (bounding) {
      if (bounding.left < 0) {
        // Left side is out of viewoprt
        if (window.innerWidth < 590) {
          setTtipWidth((window.innerWidth - 40).toString());
        }
        setTooltipPos('mobile alignLeft');
      }
      if (bounding.right > (window.innerWidth || document.documentElement.clientWidth)) {
        // Right side is out of viewport
        setTtipWidth((window.innerWidth - 40).toString());
        setTooltipPos('mobile');
      }
    }
  }, [bounding]);
  const toggleTooltip = isShow => {
    if (isShow) {
      setShowTooltip(true);
    } else {
      setShowTooltip(false);
      setAnimClass('out');
    }
  };
  // REMOVE FADEIN CLASS TO INITIATE ANIMATION FOR EVERY STEP
  (0, _react.useEffect)(() => {
    setTimeout(() => {
      if (refDesc && refDesc.current) refDesc.current.classList.remove('out');
    }, 350);
  }, [animClass]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `brixel-tooltip ${tooltipPos === 'mobile' ? '' : 'pos-r'} ${className}`
  }, !hideIcon && (/*#__PURE__*/_react.default.createElement("div", {
    className: `${classNameIconWrap} dis-f cur-poi ${showTooltip ? 'active' : ''}`,
    onMouseEnter: () => toggleTooltip(true),
    onMouseLeave: () => toggleTooltip(false)
  }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    saturation: 700,
    saturationTxt: 400,
    color: iconColor ? iconColor : 'text',
    icon: icon ? icon : 'info',
    className: "mr-small-4"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "label txtText700"
  }, label), children)), /*#__PURE__*/_react.default.createElement("div", {
    ref: refDesc,
    className: `tooltip-description txtText900 ${descClass ? descClass : ''} ${animClass} ${tooltipPos} ${showTooltip} ${theme}`,
    style: {
      width: `${tooltipWidth}px`
    }
  }, (0, _translation.default)(description, lang)));
};
var _default = exports.default = BrixelTooltip;